export const GET_AMI_INCOME_LIMITS_PATH = 'api/landlord/ami-income-limits';
